import { formatDates } from '../common/data.js'
import envConfig from '../utils/envConfig'

function normalizeTimestamp(input) {
  if (input === null || input === undefined || input === '') return input
  if (input instanceof Date) return input.getTime()
  const n = Number(input)
  if (!Number.isFinite(n)) return input
  const abs = Math.abs(n)
  if (abs > 0 && abs < 1e12) return n * 1000
  return n
}

function jointPic(value) {
  if (value) {
    return `${envConfig.origin}/imgs/${value}`
  }
}
// 超出文字中间显示省略符
function ellipsis1(value) {
  return parseFloat(value).toLocaleString()
}

// 格式化地址
function formatAddress(value) {
  if (!value) return ''
  return value.substring(0, 4) + '***' + value.substring(value.length - 4, value.length)
}

function formatDate(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'yyyy-MM-dd hh:mm:ss')
}

function formatDateYMDhm(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'yyyy-MM-dd hh:mm')
}

function formatDateMDhm(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'MM-dd hh:mm')
}

function formatDateMDhms(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'MM-dd hh:mm:ss')
}

function formatDateMD(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'MM-dd')
}

function formatDateYMD(time) {
  let date = new Date(normalizeTimestamp(time))
  return formatDates(date, 'yyyy-MM-dd')
}

function retainTailNumber(value) {
  if (value.length > 4) {
    return value.substr(value.length - 4)
  } else {
    return value
  }
}
function formatPrice(val) {
  if (!val) return '0.00'
  // For grid view with limited space, maybe round to integer or 1 decimal if needed,
  // but keeping 2 decimals for accuracy as per request.
  return val.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

// 超出文字中间显示省略符
function ellipsis(value) {
  let len = value.length
  if (!value) return ''
  if (value.length > 10) {
    return value.substring(0, 4) + '***' + value.substring(len - 4, len)
  }
  return value
}
// 超出文字中间显示省略符
function shareUrlSimplify(value) {
  let len = value.length
  if (!value) return ''
  if (value.length > 10) {
    return value.substring(0, 5) + '***' + value.substring(len - 5, len)
  }
  return value
}
// 超出文字中间显示省略符
function shareUrlSimplify2(value) {
  if (!value) return ''
  return value.substring(0, 5) + '***'
}

function Knum(value) {
  value = value + ''
  let len = value.length
  console.log(value.substring(len - 3, len))
  if (value.substring(len - 3, len) == '000') {
    return `${value.substring(0, len - 3)}K`
  }
  return value
}
function numberFormat(value) {
  var param = {}
  var k = 10000,
    sizes = ['', 'W', 'Billion', 'trillion'],
    i
  if (value < k) {
    param.value = value
    param.unit = ''
  } else {
    i = Math.floor(Math.log(value) / Math.log(k))
    param.value = (value / Math.pow(k, i)).toFixed(2)
    param.unit = sizes[i]
  }
  return param.value + param.unit
}

function number_format(number, decimals, dec_point, thousands_sep) {
  decimals = 2 //这里默认设置保留两位小数，也可以注释这句采用传入的参数
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point
  var s = n.toString().split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  } else {
    s[1] = s[1].substring(0, prec) //小数点位数超出长度时截取前面的位数
  }
  return s.join(dec)
}

// 超出文字中间显示省略符
function fixed(value) {
  return Math.floor(value * 1000) / 1000
}
function toFixed(value) {
  // if (!value) return '0.00';
  // // 将字符串转换为数字
  // let num = parseFloat(value);
  // // 保留两位小数
  // return num.toFixed(2);

  if (!value) return ''
  return parseFloat(value)
}
export default {
  jointPic,
  formatDate,
  retainTailNumber,
  ellipsis,
  formatAddress,
  formatDateMDhm,
  formatDateYMDhm,
  formatDateMD,
  formatDateYMD,
  ellipsis1,
  Knum,
  formatDateMDhms,
  fixed,
  numberFormat,
  number_format,
  toFixed,
  shareUrlSimplify,
  shareUrlSimplify2,
  formatPrice,
}
